class ItemAnimation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!sessionStorage.getItem('itemAnimationClosed')) {
      if (this.dataset.delay) {
        this.activeTimeout = window.setTimeout(() => {
          this.classList.add('hd-Banner_ItemAnimation-active')
        }, parseInt(this.dataset.delay, 10))
      } else {
        this.classList.add('hd-Banner_ItemAnimation-active')
      }
    }

    this.els.close.elements.forEach(close => {
      close.addEventListener('click', event => this.handleClose(event))
    })
  }

  handleClose (event) {
    event.stopPropagation()

    sessionStorage.setItem('itemAnimationClosed', 'true')
    this.classList.remove('hd-Banner_ItemAnimation-active')
  }
}

if (!customElements.get('item-animation')) {
  customElements.define('item-animation', ItemAnimation)
}
